import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Modal from 'srcReact/components/common2/Modal'
import Button from 'srcReact/components/common2/Button'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'
import { useDispatch, useSelector } from 'react-redux'
import { settingsActions } from 'srcReact/Settings/action'

function SelectOrganization({ showModal, hideModal, deleteAccount }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative },
    organization: { organization_list },
    settings: {
      deactivateAccData: { loading, error, data, emailSentMessage, orgId }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    return () => {
      dispatch(settingsActions.clearDeactivatedData())
    }
  }, [])

  return (
    <Modal
      isOpen={showModal}
      handleClose={hideModal}
      closeOnDocumentClick={true}
      title={t('privacy_policy.selectOrgTitle')}
      subTitle={t('account_settings.sidebar.deleteWarningGeneric')}>
      <div className={styles.orgList}>
        {organization_list &&
          organization_list.items &&
          organization_list.items.length > 0 &&
          organization_list.items.map((org, index) => {
            return (
              <div className={styles.org} key={`${org.id}_${index}`}>
                <div className={styles.orgInfo}>
                  <img src={org.picture}></img>
                  <div className={styles.orgName}>{org.name}</div>
                  <Button
                    handleClick={() => deleteAccount(org)}
                    customStyle={styles.btnSelect}
                    text={isMobile || isNative ? t('global.request') : t('global.sendRequest')}
                  />
                </div>
                {emailSentMessage && orgId === org.id && (
                  <SuccessMessage className={styles.successMessage} center={true} text={emailSentMessage} />
                )}
              </div>
            )
          })}
      </div>
    </Modal>
  )
}

export default SelectOrganization
